import { SvgProps } from '../../model/types'
import React from 'react'

const InformationFilledTriangle = (props: SvgProps) => {
	return (
		<svg
			width="452"
			height="64"
			viewBox="0 0 452 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="194" width="64" height="64" rx="32" fill="#FFE7E7" />
			<path
				d="M227.732 20.1969L239.244 40.1362C240.014 41.4696 239.052 43.1362 237.512 43.1362H214.488C212.949 43.1362 211.986 41.4696 212.756 40.1362L224.268 20.1969C225.038 18.8636 226.963 18.8636 227.732 20.1969ZM226 22.5302L215.643 40.4696H236.358L226 22.5302ZM226 36C226.737 36 227.334 36.5969 227.334 37.3333C227.334 38.0697 226.737 38.6666 226 38.6666C225.264 38.6666 224.667 38.0697 224.667 37.3333C224.667 36.5969 225.264 36 226 36ZM226 26.6666C226.737 26.6666 227.334 27.2636 227.334 28V33.3333C227.334 34.0697 226.737 34.6666 226 34.6666C225.264 34.6666 224.667 34.0697 224.667 33.3333V28C224.667 27.2636 225.264 26.6666 226 26.6666Z"
				fill="#BA1D1D"
			/>
		</svg>
	)
}

export default InformationFilledTriangle
